import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

const PopupModal = (props) => {
    const { data, isPopupOpen, setIsPopupOpen } = props;

    function closeModal() {
        setIsPopupOpen(false)
    }

    return (
        <Transition appear show={isPopupOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-40" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-gradient-to-br from-white/90 to-[#EAEAEA]/80 backdrop-blur-sm border border-[#228B22]/20 p-6 text-left align-middle shadow-2xl transition-all">
                                {/* Header with Football Theme */}
                                <div className="bg-gradient-to-r from-[#228B22] to-emerald-600 -m-6 mb-4 p-4 rounded-t-2xl">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-bold leading-6 text-white flex items-center"
                                    >
                                        <div className="w-6 h-6 bg-[#FFD700] rounded-full flex items-center justify-center mr-3">
                                            📢
                                        </div>
                                        Announcement
                                        <div className="ml-auto">
                                            <div className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse"></div>
                                        </div>
                                    </Dialog.Title>
                                    <p className="text-emerald-100 text-xs mt-1 font-medium">Latest Updates & News</p>
                                </div>

                                <div className="mt-4 space-y-3 max-h-60 overflow-y-auto">
                                    {
                                        data?.map((d, index) => (
                                            <div key={index} className='p-3 bg-white/70 rounded-xl border border-[#228B22]/10 text-sm text-gray-800 font-medium leading-relaxed hover:bg-white/90 transition-colors'>
                                                <div className="flex items-start">
                                                    <div className="w-2 h-2 bg-[#228B22] rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                                    <span>{d?.displayText}</span>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                                <div className="mt-6 w-full flex justify-center">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center items-center rounded-xl bg-gradient-to-r from-[#FFD700] to-yellow-400 px-6 py-3 text-sm font-bold text-gray-900 hover:from-yellow-400 hover:to-[#FFD700] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 border border-yellow-300"
                                        onClick={closeModal}
                                    >
                                        <span>Got it!</span>
                                        <div className="ml-2 w-4 h-4 bg-gray-900/20 rounded-full flex items-center justify-center">
                                            ✓
                                        </div>
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default PopupModal
